export const DEFAULT_MESSAGE_LIMIT = 30;
